import { createControlComponent } from '@react-leaflet/core'
import { control } from 'leaflet'
import 'leaflet.fullscreen'

export const FullScreenControl = createControlComponent((props) =>
  control.fullscreen({
    position: 'topright',
    forceSeparateButton: true,
    ...props,
  })
)
